export default __webpack_public_path__ + "static/media/thumbnail.322cafa0.png";